import { type SVGProps } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/helpers/cn.helper";

const squareIconVariants = cva("", {
  variants: {
    variant: {
      default: "text-light-400",
      unstyled: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

interface SquareIconProps
  extends SVGProps<SVGSVGElement>,
    VariantProps<typeof squareIconVariants> {
  className?: string;
}

export const SquareIcon = ({ className, variant, ...props }: SquareIconProps) => (
  <svg
    className={cn(squareIconVariants({ variant }), className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default SquareIcon;
